export const manualPrinterIds = [6, 12, 18, 17, 21, 22, 29, 33, 37];
